'use strict';
ui.loadTemplateFile('messagebox.html');

class MessageBoxDialog extends Dialog {
  _element: any;
  _titleBar: any;
  _message: any;
  _buttonArea: any;

  constructor(message: any, buttons: any, isError?: boolean) {
    super('messagebox.html');

    this._message = ui.label(this, '.label.message');
    this._buttonArea = this._element.find('.button-area');

    this._message.text(message);

    if (isError) {
      this._element.addClass('error');
    }

    if (buttons === undefined) {
      buttons = ['OK'];
    }

    for (let i = 0; i < buttons.length; ++i) {
      const button = ui.button();
      button._element.text(buttons[i]);
      button.on('clicked', this._onButtonClicked.bind(this, buttons[i]));
      this._buttonArea.append(button._element);
    }

    this.center();
  }

  _onButtonClicked(button: any) {
    this.close();
    this.emit(button.toLowerCase());
  }
}

ui.MessageBoxDialog = MessageBoxDialog;
ui.messageBox = (message: any, buttons: any, isError?: boolean) => {
  return new ui.MessageBoxDialog(message, buttons, isError);
};
